import React from "react";
import {Spin} from "antd";

import "./Loading.scss";

type ILoadingProps = {};

export default function Loading(props: ILoadingProps): JSX.Element {
  return (
    <div className="Loading">
      <Spin size="large" />
    </div>
  );
}
